export const environment = {
  api: '/api',
  production: true,
};
